export default () => window.APP_DATA;